/* ============================================================
   tc60-v4 · PRE-MADE CROSS-BRAND BUNDLES
   Two jobs, and both of them exist so there is only ONE price list on
   this page:

   1. Fill in each set's price line by reading the calculator's own chips.
      The prices live on the .bundle-chip elements as data-price, and the
      discount rule (20%, +5% when a basket spans all three brands) is the
      one tc60-v2.js applies. Duplicating either into this file — or worse,
      into the HTML — is how a mockup ends up quoting two different totals
      for the same three products.

   2. Wire "Start with this bundle" to actually press those chips, so the
      set becomes a starting point in the builder rather than a dead
      picture of one. It clicks rather than setting aria-pressed directly:
      the click handler in v2 owns the re-render, and going around it would
      leave the receipt showing the previous basket.
   ============================================================ */
(function () {
  'use strict';

  var sets = Array.prototype.slice.call(document.querySelectorAll('.bset[data-bundle]'));
  if (!sets.length) return;

  var chips = Array.prototype.slice.call(document.querySelectorAll('.bundle-chip'));
  if (!chips.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (n) { return '$' + n.toLocaleString('en-SG'); };

  /* Same rule as tc60-v2.js: 20% anniversary, +5% when the basket spans
     all three brands. Kept in step by deriving both from the chips. */
  var BASE = 0.20, CROSS_BONUS = 0.05, CROSS_AT = 3;

  var chipFor = function (name) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].dataset.name === name) return chips[i];
    }
    return null;
  };

  sets.forEach(function (set) {
    var names = set.getAttribute('data-bundle').split('|');
    var picked = names.map(chipFor);

    /* A set naming a product the calculator doesn't carry is an authoring
       mistake, not a runtime condition to paper over — say so in the
       console and leave the card without a price rather than quoting a
       total that silently omits an item. */
    var missing = names.filter(function (n, i) { return !picked[i]; });
    if (missing.length) {
      console.warn('[tc60] bundle set names not found among .bundle-chip:', missing);
      return;
    }

    var sub = picked.reduce(function (a, c) { return a + parseInt(c.dataset.price, 10); }, 0);
    var brands = {};
    picked.forEach(function (c) { brands[c.dataset.brand] = 1; });
    var rate = BASE + (Object.keys(brands).length >= CROSS_AT ? CROSS_BONUS : 0);
    var save = Math.round(sub * rate);

    var priceEl = set.querySelector('[data-bset-price]');
    if (priceEl) {
      priceEl.innerHTML =
        '<span class="was">' + money(sub) + '</span>' +
        '<span class="pay">' + money(sub - save) + '</span>' +
        '<span class="off">Save ' + money(save) + ' &middot; ' + Math.round(rate * 100) + '% off</span>';
    }

    var go = set.querySelector('.bset-go');
    if (!go) return;
    go.addEventListener('click', function () {
      /* clear whatever's currently selected, then press this set's chips.
         Each click re-renders the receipt; three redundant renders on a
         nine-chip form is not worth batching. */
      chips.forEach(function (c) {
        if (c.getAttribute('aria-pressed') === 'true') c.click();
      });
      picked.forEach(function (c) { c.click(); });

      sets.forEach(function (s) { s.classList.remove('is-applied'); });
      set.classList.add('is-applied');

      var receipt = document.querySelector('.receipt');
      if (receipt) {
        receipt.scrollIntoView({
          behavior: reduce ? 'auto' : 'smooth',
          block: 'center'
        });
      }
    });
  });
})();
